// Subscriptions moved to the Olene account on 2026-10-04 (olene-platform services/account/src/billing.ts):
// subscribing, cancelling, the card on file and past payments are at account.olenesoft.com/billing.
// /ManageSubscription stays as the way there, for the menu, the demo banner and old links.
import { useEffect } from "react";
import { ACCOUNT_URL } from "../auth/forgotUsername";
import { showTransition } from "../auth/oleneSso";

export const BILLING_URL = `${ACCOUNT_URL}/billing?app=payclear`;

export default function ManageSubscription() {
  useEffect(() => {
    showTransition("Opening your Olene account…");
    window.location.replace(BILLING_URL);
  }, []);
  return null;
}
